export default __webpack_public_path__ + "static/media/icon-192x192.40f1dc9b.png";